// extracted by mini-css-extract-plugin
export var dropdownContainer = "_oi-0";
export var leftAlign = "_oi-4";
export var listItem = "_oi-2";
export var listItemWrapper = "_oi-1";
export var operationText = "_oi-3";